import * as React from "react"

const issuesSubNavigation = [
  { name: 'Bring Federal Funding Back To Rhode Island', href: '#bring-federal-funding-back-to-rhode-island', current: true },
  { name: 'Education', href: '#education', current: false },
  { name: 'Climate and Environmental Justice', href: '#climate-environmental-justice', current: false },
  { name: 'Invest in Public Health & Healthcare', href: '#invest-public-health-healthcare', current: false },
  { name: 'Housing & Housing Affordability', href: '#housing-housing-affordability', current: false },
  { name: 'Jobs & Economic Justice', href: '#jobs-economic-justice', current: false },
  { name: 'Women\'s & Reproductive Rights', href: '#womens-reproductive-rights', current: false },
  { name: 'Seniors', href: '#seniors', current: false },
  { name: 'Veterans', href: '#veterans', current: false },
  { name: 'Small Business & the Economy', href: '#small-business-economy', current: false },
  { name: 'Immigration', href: '#immigration', current: false },
  { name: 'LGBTQIA2S+ Rights', href: '#lgbtqia2splus', current: false },
  { name: 'Public Safety & Ending Gun Violence', href: '#public-safety-ending-gun-violence', current: false },
  { name: 'Protect Our Democracy', href: '#protect-our-democracy', current: false },
  { name: 'Improve Quality of Life', href: '#improve-quality-of-life', current: false },
  { name: 'Transportation', href: '#transportation', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

/* This example requires Tailwind CSS v2.0+ */
export default function IssuesHeader() {
  return (
    <>
      <div className="bg-white">
        <div className="max-w-7xl mx-auto pt-10 pb-4 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
              Issues
            </p>
            <p className="mx-auto text-xl text-gray-500">
              John is rooted in community. John fights for all of us.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-gray-200">
        <div className="relative max-w-7xl mx-auto pb-4 px-6 xl:px-0">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
            <div className="">
              <h3 className="pt-5 font-bold text-3xl leading-relaxed">
                Overview of Issues
              </h3>
              <nav className="flex flex-1 flex-col bg-blue-bgLight" aria-label="Issue Subnavigation">
                <ul role="list" className="-mx-2 space-y-1">
                  {issuesSubNavigation.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className={classNames(
                          item.current ? 'text-xl text-white bg-blue-700' : 'text-xl text-white hover:bg-blue-700',
                          'group flex gap-x-3 pt-3 pb-3 pr-2 pl-5 text-sm leading-6 font-semibold'
                        )}
                      >
                        &raquo; {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
            <div>
              <h3 className="pt-5 font-bold text-3xl leading-relaxed">Federal Legislation That John Supports</h3>
              <iframe className="border" src="https://docs.google.com/document/d/e/2PACX-1vQd5VSlC1k9FRS8Ewspqvr8Aog2cl4_sNip5H36pCwg_inWN7lgXx1aNMGe2VPNnuCSmFh1YQau1StT/pub?embedded=true"  width="100%" height="826" frameborder="0" marginheight="0" marginwidth="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
  